/*-------------------------------------------------------
  Popup which will be shown when the user ends up on a siteview which doesn't correspond with the country they're in.
 Example: if someone visits SWNL but they're actually in Belgium, the popup will show up.

To test this:
- Add ?ip=81.241.235.211 behind your url
- Clear cookie popupSiteChoice
- Frontend file: location-site-popup.tpl
 ---------------------------------------------------- */
import { Modal } from "../modal/modal"; // @TODO: Move this file because a component cannot import another component
import axios from "axios";

const openLocationPopup = function (popupContent) {
  const locationSiteModal = new Modal({
    selector: ".location-site-modal",
    content: popupContent,
    isClosable: true,
    onModalClose: function () {
      const date = new Date();
      date.setTime(date.getTime() + 1000 * 24 * 60 * 60 * 1000);
      const expires = "expires=" + date.toUTCString();

      if (frontendVars.siteviewId === "1") {
        if (!Cookiebot.consent.preferences) {
          return;
        }

        document.cookie = "popupSiteChoice=0; " + expires + "; path=/";
      } else {
        document.cookie = "popupSiteChoice=0; " + expires + "; path=/";
      }
    },
  });
  locationSiteModal.show();
};

export const locationSitePopupInit = function () {
  if (!document.cookie.match(/popupSiteChoice=0/i)) {
    const data = {};
    const matches = window.location.search.match(
      /ip=([0-9]{1,3}(\.[0-9]{1,3}){3})/i,
    );
    const ipAddress = matches ? matches[1] : null;

    if (ipAddress) {
      data.ip = ipAddress;
    }

    axios
      .get("/locationpopup/render-popup", { params: data })
      .then(function (response) {
        if (
          response.data &&
          response.data.popupHtml &&
          response.data.popupHtml !== ""
        ) {
          openLocationPopup(response.data.popupHtml);
        }
      })
      .catch(function (error) {
        if (typeof Sentry !== "undefined") {
          Sentry.captureException(error);
        }
      });
  }
};

export default openLocationPopup;
